import { gql } from '@apollo/client';

export const createSite = gql`
  mutation createSite($siteInput: CreateSiteInput) {
    createSite(input: $siteInput) {
      altId
    }
  }
`;
